<template>
  <Page>
    <template #action>
      <BaseLink
        class="text-sm flex flex-row items-center"
        to="head.register"
      >
        <BaseIcon class="mr-3" name="arrow-left" width="4" height="8" />
        Вернуться назад
      </BaseLink>
    </template>
    <template #title>Редактирование условий ЛМСЗ</template>

    <div
      v-if="isLoading"
      class="w-full h-full flex flex-row items-center justify-center"
    >
      <BaseLoader size="3xl" />
    </div>
    <LMSPForm v-else :data="lmsp" />
  </Page>
</template>

<script>
  import {mapState} from 'vuex';

  import BaseLink from '@/components/global/base-link';
  import BaseIcon from '@/components/global/base-icon';
  import Page from '@/components/layouts/main/page/index';
  import BaseLoader from '@/components/global/base-loader';
  import LMSPForm from '@/components/views/lmsp/form/index';

  export default {
    name: 'OperatorRegistryDetailPage',

    components: {
      Page,
      BaseIcon,
      BaseLink,
      LMSPForm,
      BaseLoader,
    },

    data() {
      return {
        isLoading: false,
      };
    },

    computed: {
      ...mapState('LMSPRequest', ['lmsp']),
    },

    created() {
      this.isLoading = true;

      this.$store
        .dispatch('LMSPRequest/load', this.$route.params.id)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.$store.commit('Notification/showAlert', {
            title: 'Ошибка!',
            message:
              'Произошла ошибка, пожалуйста попробуйте обновить страницу.',
          });
        });
    },

    destroyed() {
      this.$store.dispatch('LMSPRequest/clear');
    },
  };
</script>
